module.exports = __webpack_public_path__ + "img/1f408-200d-2b1b.852880a.svg";